module.exports = __webpack_public_path__ + "static/media/msp_17.4f2288bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msp_17.png
// module id = 190
// module chunks = 1